import { User } from 'src/api/generated/models/User';

export const findUser = (userId: number | null, users: User[]): User | null => {
  if (!userId) return null;

  return users.find((user) => user.id === userId) || null;
};
